<template>
  <section class="c-expressSection">
    <div class="main-container">
      <div class="content-container">
        <h2>Make the most of your journey</h2>
        <div class="c-expressSection__advantagesContainer">
          <div class="c-expressSection__advantage">
            <div class="c-expressSection__advantageImgContainer" :style="{ 'background-image': 'url(' + allianceImg + ')' }">
            </div>
            <div class="c-expressSection__advantageText">
              <p class="c-expressSection__advantageTitle">Sky World Alliance</p>
              <p class="c-expressSection__advantageSubtitle">Sky World gives you an even greater choice. Enjoy seamless transfers and earn Liberty Advantage points.</p>
            </div>
          </div>
          <div class="c-expressSection__advantage">
            <div class="c-expressSection__advantageImgContainer" :style="{ 'background-image': 'url(' + loungeImg + ')' }">
            </div>
            <div class="c-expressSection__advantageText">
              <p class="c-expressSection__advantageTitle">Liberty Lounge</p>
              <p class="c-expressSection__advantageSubtitle">There’s no place like home, but the Liberty Lounge is pretty close. Work or rest in maximum comfort before you fly.</p>
            </div>
          </div>
        </div>
        <div class="c-expressSection__bannerContainer">
          <img title="Express Lane" src="@/assets/express_lane.svg">
          <div class="c-expressSection__bannerTextBlock">
            <div class="c-expressSection__bannerText">
              <p>There’s no need to wait</p>
              <span>The Express Lane ensures you will be the first through airport security and boarding.</span>
            </div>
            <Button class="buttonDesktop" name="Learn more" color="blue" :transparent="true"></Button>
          </div>
        </div>
        <Button class="buttonTablet" name="Learn more" color="blue" :transparent="true"></Button>
      </div>
    </div>
  </section>
</template>

<script>
import Button from '@/components/Button'

export default {
  name: 'ExpressSection',
  data () {
    return {
      allianceImg: require('@/assets/alliance_cover.jpg'),
      loungeImg: require('@/assets/lounge_cover.jpg')
    }
  },
  components: {
    Button
  }
}
</script>

<style lang="scss" scoped>
@import "@/scss/variables.scss";

.c-expressSection {

  .content-container {
    padding: 70px 0 80px 0;
    display: block;
  }

  h2 {
    font-weight: bold;
    padding-bottom: calc(#{$base-padding} * 2)
  }

  &__advantagesContainer {
    display: flex;
    justify-content: space-between;
    width: 100%;
    margin-bottom: $base-margin
  }

  &__advantage {
    width: calc(50% - calc(#{$base-margin / 2}));
    box-shadow: 0px 2px 4px 0 rgba(0, 0, 0, 0.3);
    cursor: pointer;
    transition: box-shadow 0.2s ease-in-out;
    border-radius: 2px;

    &:hover {
      box-shadow: 0px 6px 12px 0 rgba(0, 0, 0, 0.3);
    }
  }

  &__advantageImgContainer {
    height: 300px;
    border-top-right-radius: 2px;
    border-top-left-radius: 2px;
    background-position: center;
    background-repeat: no-repeat;
    background-size: cover;
  }

  &__advantageText {
    text-align: left;
    padding: $base-padding;
  }

  &__advantageTitle {
    font-weight: bold;
    font-size: 20px;
    color: $blue;
    margin-bottom: $base-margin;
  }

  &__advantageSubtitle {
    font-size: 16px;
    color: $light-grey;
  }

  &__bannerContainer {
    width: 100%;
    display: flex;
    justify-content: space-between;
    padding: $base-padding;
    box-shadow: 0px 2px 4px 0 rgba(0, 0, 0, 0.3);
    background-image: url('~@/assets/express_lane_bg.svg');
    background-size: 48% 102%;
    background-position: left;
    background-repeat: no-repeat;
    align-items: center;
    border-radius: 2px;

    img {
      height: 36px;
    }
  }

  &__bannerTextBlock {
    display: flex;
    justify-content: space-between;
    align-items: center;
    width: calc(50% - calc(#{$base-margin} / 2));
  }

  &__bannerText {
    text-align: left;
    width: 60%;

    p {
      font-weight: bold;
      font-size: 20px;
      color: $blue;
      margin-bottom: calc(#{$base-margin / 3});
    }

    span {
      font-size: 16px;
      color: $light-grey;
    }
  }

  .buttonTablet {
    display: none;
  }
}

@include desktop-sm {
  .c-expressSection {
    .content-container {
      text-align: center;
    }

    &__bannerContainer {
      background-size: 50% 64%;

      img {
        width: 28%;
        height: auto;
      }
    }

    .buttonDesktop {
      display: none;
    }

    .buttonTablet {
      display: block;
      margin: 30px auto 0 auto;
    }

    &__bannerTextBlock {
      display: flex;
      justify-content: space-between;
      align-items: center;
      width: calc(50% - calc(#{$base-margin} / 2));
    }

    &__bannerText {
      width: 100%;
    }
  }
}

@include tablet {
  .c-expressSection {
    .content-container {
      padding: 40px 0 50px 0;
    }

    &__advantageImgContainer {
      height: 200px;
    }

    &__advantageTitle {
      font-size: 16px;
    }

    &__advantageSubtitle {
      font-size: 14px;
    }

    &__bannerText {
      p {
        font-size: 16px;
      }

      span {
        font-size: 14px;
      }
    }
  }
}

@include phone {
  .c-expressSection {
    &__advantagesContainer {
      flex-direction: column;
    }

    &__advantage {
      width: 100%;

      &:first-child {
        margin-bottom: $base-margin;
      }
    }

    &__advantageImgContainer {
      height: 300px;
    }

    &__bannerContainer {
      img {
        display: none;
      }
      background: none;
    }

    &__bannerTextBlock {
      width: 100%;
    }
  }
}
</style>
